// extracted by mini-css-extract-plugin
export default {"layoutSt":"layout_layoutSt__wDhiX"};